<template>
  <div class="p-6 md:p-10 pb-0">
    <NumberingSettings ref="numbering" settings-key="vouchers" default-prefix="AEH-" label="voucher" />
  </div>
  <AdminCrudPage
    collection-name="vouchers"
    title="Vouchers"
    singular-title="Voucher"
    :fields="fields"
    :columns="columns"
    print-route="/admin/vouchers/print"
    :default-values="getDefaultValues"
    :on-added="handleAdded"
  />
</template>

<script>
import AdminCrudPage from './AdminCrudPage.vue'
import NumberingSettings from '../../components/NumberingSettings.vue'
import { getSettings, setSettings } from '../../services/settingsStore'

function todayFormatted() {
  return new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}

const DEFAULT_NOTES = `Hotel Details:
- Children: Two Children under 6 years are allowed.
- Check in: 16:00. Early arrival subject to availability.
- Check out: 12:00. After 14:00 one night will be charged.

Terms & Conditions:
- In case of a no-show for an individual or group, the full amount will be charged.
- Only standard double beds are available. For triple and quad occupancy, an extra bed will be provided.
- In case of late check-in, the passenger must inform us on a timely basis so that necessary arrangements can be made.

Cancellation Policy:
- Umrah Bookings are not cancelable, non-refundable and non-changeable.`

export default {
  name: 'AdminVouchers',
  components: { AdminCrudPage, NumberingSettings },
  data() {
    return {
      columns: [
        { key: 'voucherNo', label: 'Voucher No' },
        { key: 'customerName', label: 'Customer' },
        { key: 'hotelName', label: 'Hotel' },
        { key: 'rooms', label: 'Rooms', compute: item => (item.rooms || []).length },
        { key: 'bookingType', label: 'Type' }
      ],
      fields: [
        { key: 'voucherNo', label: 'Voucher No (auto-generated, editable)', type: 'text', required: true },
        { key: 'issueDate', label: 'Issue Date (e.g. 23 Aug 2026)', type: 'text', required: true },
        { key: 'customerName', label: 'Customer Name', type: 'text', required: true },
        { key: 'customerPhone', label: 'Customer Phone', type: 'text' },
        {
          key: 'bookingType',
          label: 'Booking Type',
          type: 'select',
          options: ['Umrah Package', 'Hotel Booking', 'Flight Booking', 'Ziarat Tour', 'Custom Service']
        },
        { key: 'hotelName', label: 'Hotel Name', type: 'text' },
        { key: 'rooms', label: 'Rooms (add one row per room booked)', type: 'roomRows' },
        { key: 'inclusions', label: 'Inclusions', type: 'stringList', example: 'Return flights, Visa processing, Airport transfers' },
        { key: 'hasExtra', label: 'Something Extra?', type: 'boolean', checkboxLabel: 'Add an extra item to this voucher' },
        { key: 'extraTitle', label: 'Extra Title', type: 'text', showIf: 'hasExtra' },
        { key: 'extraDescription', label: 'Extra Description', type: 'textarea', showIf: 'hasExtra' },
        { key: 'notes', label: 'Notes / Terms', type: 'textarea' }
      ]
    }
  },
  methods: {
    async getDefaultValues() {
      const settings = await getSettings('vouchers', { prefix: 'AEH-', nextNumber: 1001 })
      return {
        voucherNo: `${settings.prefix}${settings.nextNumber}`,
        issueDate: todayFormatted(),
        notes: DEFAULT_NOTES
      }
    },
    async handleAdded() {
      const settings = await getSettings('vouchers', { prefix: 'AEH-', nextNumber: 1001 })
      await setSettings('vouchers', { ...settings, nextNumber: settings.nextNumber + 1 })
      if (this.$refs.numbering) await this.$refs.numbering.refresh()
    }
  }
}
</script>
